import { Skeleton } from '@mui/material'
import { useRefresh } from 'ContextProviders/RefreshProvider'
import { StyledProgressBar } from 'Components/ProgressBar/StyledProgressBar'
import { useEffect, useState } from 'react'
import { sendGet } from 'hooks/use-fetch'

export interface ProgramTrackerProps {
  programId: number
  sessionId: number
  onDisplay?: (noCapacityLimit: boolean, enrolled: number, capacity: number) => void
}

interface SessionData {
  maxCapacity: number
  currentCount: number
  programCode: string
  noMaxCapacity: boolean
}

export function ProgramTracker (props: ProgramTrackerProps): JSX.Element {
  const [sessionData, setSessionData] = useState<SessionData | null>()
  const refresh = useRefresh()
  useEffect(() => {
    const loadData = async (): Promise<void> => {
      const { response } = await sendGet(`/NewEnrollment/GetSessionUtilization?programId=${props.programId}&sessionId=${props.sessionId}`, {})
      setSessionData(response)
      if (props.onDisplay != null) {
        props.onDisplay(response.noMaxCapacity, response.currentCount, response.maxCapacity)
      }
    }
    void loadData()
  }, [props.programId, props.sessionId, refresh])
  if (sessionData == null) {
    return <Skeleton />
  } else {
    return <StyledProgressBar value={sessionData?.currentCount} max={sessionData?.maxCapacity} text={sessionData?.programCode} noCapacity={sessionData.noMaxCapacity} />
  }
}
